import { useEffect, useRef, useState } from 'react';

// A single shared scroll-progress ref + listener.
// progress goes 0 -> 1 over the entire <main> storytelling container.
export function useScrollProgress(containerRef) {
  const progressRef = useRef(0);
  const [activeSegment, setActiveSegment] = useState(0);
  const segmentsCount = 20;

  useEffect(() => {
    let raf;
    const handle = () => {
      const el = containerRef.current;
      if (!el) return;
      const rect = el.getBoundingClientRect();
      const total = el.offsetHeight - window.innerHeight;
      const scrolled = Math.min(Math.max(-rect.top, 0), Math.max(total, 1));
      const p = total > 0 ? scrolled / total : 0;
      progressRef.current = p;
      const idx = Math.min(segmentsCount - 1, Math.max(0, Math.floor(p * segmentsCount)));
      setActiveSegment((prev) => (prev === idx ? prev : idx));
    };
    const onScroll = () => {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(handle);
    };
    handle();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
      if (raf) cancelAnimationFrame(raf);
    };
  }, [containerRef]);

  return { progressRef, activeSegment, segmentsCount };
}
